import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Fab, Tooltip } from '@mui/material';
import Update from '@mui/icons-material/Update';
import { Button, Dialog, TextField } from '@totalsoft/rocket-ui';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const OfferAssetChassisNumberPopupComponent = ({
  t,
  chassisNumberError,
  chassisNumber,
  handleChassisNumberSave,
  updating,
  handleCancelChassisNumberSave,
  initialChassisNumber,
  open,
  setOpen,
  handleChange,
  localChassisNumber
}) => {
  const handleClose = () => {
    setOpen(false);
    handleCancelChassisNumberSave(initialChassisNumber);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <Tooltip title={t('OfferEdit.Asset.ChassisNumberUpdate')} placement='bottom'>
        <Fab
          id={'offerAssetCard_assetActions_chassisNumberUpdate'}
          color='primary'
          onClick={handleClickOpen}
          style={{ boxShadow: 'none' }}
          size='small'
        >
          <Update />
        </Fab>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
        title={t('OfferEdit.Asset.AddChassisNumber')}
        content={
          <TextField
            id={'offerAssetCard_assetActions_chassisNumberUpdate_chassisNumber'}
            required
            fullWidth
            error={Boolean(chassisNumberError)}
            helperText={chassisNumberError}
            disabled={updating}
            onChange={handleChange}
            label={t('OfferEdit.Asset.Info.ChassisNumber')}
            value={localChassisNumber || ''}
          />
        }
        actions={
          <BoxActionsWrapper forDialog>
            <Button
              id={'offerAssetCard_assetActions_chassisNumberUpdate_cancelBtn'}
              onClick={handleClose}
              disabled={updating}
              color='primary'
              variant='outlined'
            >
              {t('Cancel')}
            </Button>
            <Button
              id={'offerAssetCard_assetActions_chassisNumberUpdate_saveBtn'}
              onClick={handleChassisNumberSave}
              disabled={chassisNumber === initialChassisNumber || chassisNumberError !== '' || updating}
              color='primary'
              variant='contained'
            >
              {t('Save')}
            </Button>
          </BoxActionsWrapper>
        }
      />
    </div>
  );
};

OfferAssetChassisNumberPopupComponent.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleChassisNumberSave: PropTypes.func.isRequired,
  handleCancelChassisNumberSave: PropTypes.func.isRequired,
  updating: PropTypes.bool.isRequired,
  updatingChassisNumber: PropTypes.bool,
  chassisNumber: PropTypes.string,
  chassisNumberError: PropTypes.string,
  localChassisNumber: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  initialChassisNumber: PropTypes.string
};

export default compose(withTranslation())(OfferAssetChassisNumberPopupComponent);
